import { useMatches } from 'react-router';
import type { RouteHandle } from '@/shared/config';

const isRouteHandle = (value: unknown): value is RouteHandle =>
  typeof value === 'object' && value !== null && 'page' in value && 'icon' in value;

/** The deepest matched route's `handle` (page key + icon), if it declares one. */
export function useRouteHandle(): RouteHandle | undefined {
  const matches = useMatches();
  for (let i = matches.length - 1; i >= 0; i--) {
    const handle = matches[i]?.handle;
    if (isRouteHandle(handle)) return handle;
  }
  return undefined;
}
